import { TableFooter as MuiTableFooter, type TableFooterProps as MuiTableFooterProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';
import { TableRowHoverContext } from '../TableRow/TableRowHoverContext';

type Props = WithoutStyleOverrides<MuiTableFooterProps>;

export function TableFooter(props: Props) {
  return (
    <TableRowHoverContext.Provider value={false}>
      <MuiTableFooter {...props} />
    </TableRowHoverContext.Provider>
  );
}

export type { Props as TableFooterProps };
